<template>
  <DBox
    :id="'cmp-royalty-royalty_accounts-sidewindow-accounting_statement'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('new')} ${$t('statement_string')}`"
    @addClick="onAddClick"
    :rightMenu="[

    ]"
    @menuClick="onRightMenuClick"
  >
  <!-- {
        text: $t('update_b2b_data'),
        value: 'update_b2b_data',
      }, -->
    <NTable
      class="dbox1"
      id="royalty-royalty_accounts-sidewindow-related_contacts-list"
      :config="tableConfig"
      :headers="headers"
      :items="list"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <template v-if="!item.royalty_period_amount">
          <tr>
            <td v-bind="tdcon('start_date')">
              <span class="txtov" :title="item['start_date']">
                {{ item["start_date"] }}
              </span>
            </td>
            <td v-bind="tdcon('end_date')">
              <span class="txtov" :title="item['end_date']">
                {{ item["end_date"] }}
              </span>
            </td>
            <div
              class="ut-flex ut-rowcen"
              style="width: 100%; display: flex; justify-content: center"
            >
              <span title="in process..please wait" class="ut-text-secondary"
                >In process...please wait</span
              >
              <img
                style="width: 10px; height: 10px; margin-left: 8px"
                src="static/icons/loading.gif"
                alt
              />
            </div>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td v-bind="tdcon('start_date')">
              <span
                @click.stop="(e) => onSelectStatement(item)"
                class="txtov ut-link ut-text-accent5"
                :title="item['start_date']"
              >
                {{ item["start_date"] }}
              </span>
            </td>
            <td v-bind="tdcon('end_date')">
              <div><span class="txtov" :title="item['end_date']">
                {{ item["end_date"] }}
              </span>&nbsp;
                  <b
                    class="ut-text-accent"
                    v-if="item['duplicate_royalty_period']"
                    >!!!</b
                  ></div>
            </td>
            <td v-bind="tdcon('opening')">
              <span
                class="txtov text-right"
                :title="item['opening_period_all']"
              >
                {{ $dft.curr(item["opening_period_all"]) }}
              </span>
            </td>
            <td v-bind="tdcon('add_ded')">
              <span class="txtov" :title="item['additions']">
                {{ $dft.curr(item["additions"]) }}
              </span>
            </td>
            <td v-bind="tdcon('royalty')">
              <span class="txtov text-right" :title="item['royalty_amount']">
                {{ $dft.curr(item["royalty_amount"]) }}
              </span>
            </td>
            <td v-bind="tdcon('payment')">
              <span class="txtov text-right" :title="item['payment_gross_all']">
                {{ $dft.curr(item["payment_gross_all"]) }}
              </span>
            </td>
            <td v-bind="tdcon('closing')">
              <span
                class="txtov text-right"
                :title="item['closing_period_contract_all']"
              >
                {{ $dft.curr(item["closing_period_contract_all"]) }}
              </span>
            </td>
            <td v-bind="tdcon('notes')">
              <TextField2
                :id="'notes'"
                :type="'text'"
                :showLabel="false"
                :disabled="item['disabled']"
                :value="item['notes']"
                @blur="(e) => onTextFieldValueChange(e, item)"
                :bb="'0px'"
              />
            </td>

            <td v-bind="tdcon('credit_note')">
              <span
                @click.stop="(e) => onSelectCreditNote(item)"
                class="txtov ut-link ut-text-accent5"
                :title="item['invoice_ref']"
                v-if="
                  item.royalty_ref != 'manual' && item.royalty_ref != 'payment'
                "
              >
                {{ item["invoice_ref"] }}
              </span>
              <div
                class="ut-flex ut-jbetween"
                v-if="item.royalty_ref == 'manual'"
              >
                <span
                  :title="
                    getPaymentDate(item) || $t('payment_date_not_available')
                  "
                >
                  {{ getPaymentDate(item) || "N/A" }}
                </span>
                <!-- <div class="dt-icon-container">
                  <img
                    @click.stop="(e) => onStatementEditClick(item)"
                    src="static/icons/edit-blue.svg"
                    class="dt-icon v5 s2"
                    :alt="$t('edit_statement')"
                    :title="$t('edit_statement')"
                  />
                </div> -->
              </div>
            </td>
            <td v-bind="tdcon('link')">
              <div style="margin: 0px">
                <a
                  v-if="item['lock_flag'] == 1 && item['total_ext_users'] > 0"
                  target="_blank"
                  @click.stop="(e) => openB2b()"
                >
                  <img
                    src="static/icons/eye.svg"
                    class="dt-icon v5 s2"
                    alt="shares preview"
                    title="shares preview"
                /></a>
                <img
                  v-if="item['lock_flag'] == 1"
                  @click.stop="(e) => onLockClick(item)"
                  src="static/icons/booking/lock-closed.svg"
                  class="dt-icon v5 s2"
                />

                <img
                  v-if="!item['lock_flag'] || item['lock_flag'] == 0"
                  @click.stop="(e) => onLockClick(item)"
                  color="black"
                  src="static/icons/booking/lock-open.svg"
                  class="dt-icon v5 s2"
                  alt="Lock Invoice"
                  title="Lock Invoice"
                />

                <img
                  @click.stop="(e) => onStatementWindow(item)"
                  src="static/icons/email/email-grey.svg"
                  class="dt-icon v5 s2"
                  alt="Mail Account"
                  title="Mail Account"
                />
                <img
                  @click.stop="(e) => onStatementPrint(item)"
                  src="static/icons/printer.svg"
                  class="dt-icon v5 s2"
                  alt="Print"
                  title="Print"
                />
              </div>
            </td>

            <td v-bind="tdcon('options')">
              <img
                v-if="item['lock_flag'] != 1 && !isDeleteLoading(item)"
                src="static/icons/delete.svg"
                @click.stop="(e) => onStatementDelete(item)"
                class="dt-icon v5 s2"
                alt
              />
              <LoadingUI
                style="margin: 0px !important"
                v-if="isDeleteLoading(item)"
              />
            </td>
          </tr>
        </template>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { JSONX, openWindow, sendMailHref } from "../../../../utility";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { accountsRoyaltyActions } from "../../store/accounts/actions";
import { AccountsService } from "../../services/accounts.service";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { getBaseUrl } from "../../../../services/http/http-client";
import { statementsListLDTRoutes } from "../../router/routes";
import { costListLDTRoutes } from "../../../accounting/router/routes";
import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import { showNotification } from "../../../../dt-plugins/notification/notification.service";
import { LoadingUI } from "@plugins/loading/loading";

export default {
  components: {
    ModalContainer,
    DBox,
    NTable,
    LoadingUI,
  },
  props: ["selectedAccountDetails"],
  data: () => ({
    selectedStatement: null,
    tableConfig: createNTableConfig({
      headerStyle: 3,
      fullHeight: true,
    }),

    deleteLoading: {},
  }),
  mounted() {},
  computed: {
    list: function () {
      return this.selectedAccountDetails?.statement_data || [];
    },
    creditNoteColumnHeader() {
      const allManual = this.list.every((b) => b.royalty_ref === "manual");

      const allPayment = this.list.every((b) => b.royalty_ref === "payment");

      if (allManual) {
        return this.$t("payment_info");
      }
      if (allPayment) {
        return false;
      }
      return this.$t("credit_note");
    },
    headers: function () {
      return [
        createTableHeader("start_date", {
          f: 1.1,
          minw: 100,
          mw: 100,
        }),
        createTableHeader("end_date", { f: 1.1, minw: 110, mw: 110 }),
        createTableHeader("opening", { ta: "right" }),
        createTableHeader("add_ded", { ta: "right" }),
        createTableHeader("royalty", { ta: "right" }),
        createTableHeader("payment", { ta: "right" }),
        createTableHeader("closing", { ta: "right" }),
        createTableHeader("notes", { f: 1.1 }),
        createTableHeader("credit_note", {
          f: 1.1,
          minw: 110,
          text: this.creditNoteColumnHeader,
        }),
        createTableHeader("link", { text: false, minw: 120, ta: "right" }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),
    onAddClick: function () {
      console.log(this.list);
      console.log("this.selectedAccountDetails", this.selectedAccountDetails);
      this.$emit("add_click", "add_statement_form");
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onStatementDelete: async function (item) {
      this.setDeleteLoading(item, true);
      const res = await AccountsService.countRoyaltyPeriodPayment(
        item?.royalty_period_id
      );
      if (res.data.request_status == "SUCCESS") {
        const res1 = await AccountsService.royaltyPeriodInvoiceInfo(
          item?.royalty_period_id
        );
        this.invoiceInfo = res1.data.invoice;
        if (this.invoiceInfo) {
          this.selectedStatement = {
            ...item,
          };
          this.$emit("selectedStatement", {
            selectedStatement: { ...item },
            invoiceInfo: this.invoiceInfo,
          });
          openModalRoute(this, "delete_statement_modal", {
            mode: "add",
          });
          this.setDeleteLoading(item, false);
        } else {
          showNotification(this.$t("in_process_of_deleting"));

          // const statements = this.selectedAccountDetails?.statement_data.filter(
          //   (b) => b.royalty_period_id !== item.royalty_period_id
          // );

          // this[ActionTypes.RoyaltyAccountsStatements.SET.ALL]({
          //   royalty_account_id:
          //     this.selectedAccountDetails?.account?.royalty_account_id,
          //   statement_data: [...statements] || [],
          // });

          this.$emit('delete_statement', {
            royalty_period_id: item.royalty_period_id,
            royalty_period_bundle_id: item.royalty_period_bundle_id,
          });

          // const res2 = await AccountsService.removeRoyaltyPeriod({
          //   ...item,
          // });

          this.setDeleteLoading(item, false);
        }
      }
    },
    onTextFieldValueChange: function ({ name, value }, item) {
      this.$emit("changed", {
        name,
        value,
        kVal: item.royalty_period_id,
        table: "l_royalty_periods",
      });
      // this.updateData(item);
    },

    onLockClick: function (item) {
      const value = +item.lock_flag === 0 ? 1 : 0;
      // item.lock_flag = item.lock_flag == 0 ? 1 : 0;
      this.$emit("changed", {
        name: "lock_flag",
        value: value,
        kVal: item.royalty_period_id,
        table: "l_royalty_periods",
      });
      // this.updateData(item);
    },
    onStatementWindow: function (item) {
      const body =
        item.total_ext_users > 0 && item.shared_key
          ? `B2B login URL: ${item.b2b_login_url}\n Statement URL: ${item.stmt_link}\nShared-key: ${item.shared_key}`
          : item.total_ext_users > 0 && !item.shared_key
          ? `B2B login URL: ${item.b2b_login_url}\n Statement URL: ${item.stmt_link}`
          : item.shared_key
          ? `Statement URL: ${item.stmt_link}\nShared-key: ${item.shared_key}`
          : `Statement URL: ${item.stmt_link}`;

      const subject = `Royalty Statement ${item.royalty_account_name} ${item.start_date}-${item.end_date}`;

      const mails = [item.email];

      console.log("subject,body,recepient", subject, body, mails);
      sendMailHref({ subject, body, mails });
       if(!item.lock_flag){
        this.onLockClick(item);
       }
    },
    openB2b() {
      this.$emit("add_click", "external_user_list_modal");
    },

    onSelectCreditNote(item) {
      this.$router.push({
        name: costListLDTRoutes.names.tab,
        params: {
          invoice_id: item.invoice_id,
          tab: "overview",
        },
      });
    },
    onStatementPrint(item) {
      openWindow(item.stmt_link, "_blank", { wr: 0.7, hr: 0.7 });
    },
    onRightMenuClick: async function (menu) {
      const res = await AccountsService.updateB2BData(
        this.selectedAccountDetails?.account?.royalty_account_id
      );
      const res1 = await AccountsService.get_royalty_account_statements(
        this.selectedAccountDetails?.account?.royalty_account_id
      );
      this[ActionTypes.RoyaltyAccountsStatements.SET.ALL]({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        statement_data: res1.data.royalty_periods || [],
      });
    },
    onSelectStatement(item) {
      this.$router.push({
        name: statementsListLDTRoutes.names.tab,
        params: {
          royalty_period_id: item.royalty_period_id,
          tab: "overview",
        },
      });
    },
    onStatementEditClick(item) {
      this.$emit("edit_click", item);
    },
    // updateData: function (item) {
    //   const statements = this.selectedAccountDetails.statement_data.map((b) => {
    //     if (b.royalty_period_id === item.royalty_period_id) {
    //       b = {
    //         ...item,
    //       };
    //     }
    //     return b;
    //   });

    //   this[ActionTypes.RoyaltyAccountsStatements.SET.ALL]({
    //     royalty_account_id:
    //       this.selectedAccountDetails?.account?.royalty_account_id,
    //     statement_data: statements || [],
    //   });
    // },
    isDeleteLoading: function (item) {
      return this.deleteLoading?.[item.royalty_period_id];
    },
    setDeleteLoading: function (item, value) {
      this.deleteLoading = {
        ...this.deleteLoading,
        [item.royalty_period_id]: value,
      };
      if (!value) {
        this.deleteLoading = Object.keys(this.deleteLoading).reduce(
          (acc, key) => {
            if (this.list.find((b) => `${b.royalty_period_id}` === `${key}`)) {
              acc[key] = this.deleteLoading[key];
            }
            return acc;
          },
          {}
        );
      }
    },
    getPaymentDate(item) {
      return JSONX.tryParse(item?.json_data)?.result?.payment_date;
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-royalty-royalty_accounts-sidewindow-accounting_statement {
  .link {
    padding-top: 10px;
  }
}
</style>
